"use strict";
/**
 * CrudeAppComponents extrahiert das template aus dem appLayout
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var crude_selector_1 = require("../../store/crude/crude.selector");
var crudeActions = __importStar(require("../../store/crude/crude.actions"));
var DropDownComponent_1 = __importDefault(require("../../shared/components/FormComponents/DropDownComponent"));
var react_i18next_1 = require("react-i18next");
var ResponsiveTabComponent = function (props) {
    var history = react_router_1.useHistory();
    var dispatch = react_redux_1.useDispatch();
    var t = react_i18next_1.useTranslation().t;
    var crudePath = react_redux_1.useSelector(crude_selector_1.getCrudePath) || '';
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeTabs = react_redux_1.useSelector(crude_selector_1.getCrudeTabs);
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var activeCrudeTab = react_redux_1.useSelector(crude_selector_1.getActiveTab) || 0;
    var storedTableFilterSettings = react_redux_1.useSelector(crude_selector_1.getTableFilterSettings);
    var initialPath = window.location.pathname.replace(crudePath + "/", '');
    var pathArray = initialPath.split('/');
    var initialSelectedEntity = pathArray[0] || initialPath;
    dispatch(crudeActions.setActiveEntity(initialSelectedEntity));
    var index = crudeTabs ? crudeTabs.findIndex(function (tab) { return tab.entity === initialSelectedEntity; }) : 0;
    var _a = react_1.useState(activeCrudeTab > -1 ? activeCrudeTab : 0), selectedTabIndex = _a[0], setSelectedTabIndex = _a[1];
    var _b = react_1.useState([]), tabOptions = _b[0], setTabOptions = _b[1];
    react_1.useEffect(function () {
        setSelectedTabIndex(activeCrudeTab > -1 ? activeCrudeTab : 0);
    }, [activeCrudeTab]);
    react_1.useEffect(function () {
        if (crudeTabs) {
            var initialTab = index > -1 ? index : 0;
            if (initialTab > -1 && crudeTabs.length !== 0) {
                setSelectedTabIndex(initialTab);
                dispatch(crudeActions.setActiveTab(initialTab));
                var newPath = crudePath + "/" + (crudeTabs && crudeTabs[initialTab].entity) + "/" + (pathArray[1] || '');
                history.push(newPath);
            }
            var tabOptions_1 = [];
            crudeTabs && crudeTabs.map(function (tab, index) {
                var _a, _b;
                var label = tab.entity;
                var description;
                // prüfen, pob Labels vorhanden
                var entityLabels = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[tab.entity];
                if (entityLabels && entityLabels.title) {
                    label = entityLabels.title;
                    description = entityLabels.description;
                }
                // ggf. durch eigene Labels aus der crudeConfig überschreiben
                var configTab = (_b = crudeConfig.tabs) === null || _b === void 0 ? void 0 : _b.find(function (configTab) { return configTab.entity === tab.entity; });
                if (configTab && configTab.label && [crudeLanguage] && configTab.label[crudeLanguage]) {
                    label = configTab.label[crudeLanguage];
                }
                if (!tab.hideEntity) {
                    tabOptions_1.push({
                        key: index,
                        value: label,
                        description: description,
                    });
                }
            });
            setTabOptions(tabOptions_1);
        }
    }, [crudeTabs]);
    var triggerEntityChange = function (entity) {
        window.dispatchEvent(new CustomEvent('CrudeEntityChange', { detail: entity }));
    };
    var changeOption = function (value) {
        var _a;
        if (crudeTabs) {
            var entity = crudeTabs[value].entity;
            if (value > -1) {
                var newPath = crudePath + "/" + (crudeTabs && crudeTabs[value].entity);
                if (selectedTabIndex !== value) {
                    var changeSettings = __assign(__assign({}, storedTableFilterSettings), (_a = {}, _a[entity] = __assign(__assign({}, storedTableFilterSettings[entity]), { 0: __assign(__assign({}, storedTableFilterSettings[entity][0]), { page: 0, search: '', filter: {} }) }), _a));
                    dispatch(crudeActions.setTableFilterSettings(changeSettings));
                }
                crudeTabs && dispatch(crudeActions.setActiveEntity(crudeTabs[value].entity));
                history.push(newPath);
                triggerEntityChange(crudeTabs[value].entity);
                setSelectedTabIndex(value);
            }
        }
    };
    return (react_1.default.createElement(DropDownComponent_1.default, { size: 'small', value: tabOptions[index], disableClearable: true, fullWidth: true, options: tabOptions, label: t('crude:selectEntity'), onChange: function (value) { return changeOption(value === null || value === void 0 ? void 0 : value.key); } }));
};
exports.default = ResponsiveTabComponent;
